import { IFINotifications } from '../../../cimsPage/instances/ifi'
import { Notifications } from '../../common'

const { Edit, View } = Notifications({
  page: IFINotifications,
  view: 'b59159dc-1fd7-44ff-b6cc-f10453ffa6d9',
  edit: '249235b2-f8bb-4086-a38a-4f9f09c1e706',
})

export const ViewIFINotification = View
export const EditIFINotification = Edit

export type IFINotificationPermission =
  | typeof ViewIFINotification
  | typeof EditIFINotification
